import { render, staticRenderFns } from "./PayMethodCard.vue?vue&type=template&id=ad79033e&scoped=true"
import script from "./PayMethodCard.vue?vue&type=script&lang=js"
export * from "./PayMethodCard.vue?vue&type=script&lang=js"
import style0 from "./PayMethodCard.vue?vue&type=style&index=0&id=ad79033e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad79033e",
  null
  
)

export default component.exports